import e from"styled-components";import{theme as i}from"../../../theme.js";const a=e.div`
  padding: ${i.spacing*4}px;
  box-shadow: ${i.boxShadow};
  border-radius: ${i.radius}px;
  hr {
    margin: ${i.spacing*6}px ${i.spacing*-4}px ${i.spacing*4}px;
    border: 1px solid ${i.colors.gray[200]};
    &.small-margin {
      margin: ${i.spacing*4}px ${i.spacing*-4}px;
    }
  }
  .labels-margin {
    padding-left: ${i.spacing*8}px;
  }
`,n=e.h1`
  font-size: 24px;
  font-weight: 700;
  color: ${i.colors.gray[900]};
  margin: 0 0 ${i.spacing*2}px 0;
`,r=e.p`
  color: ${i.colors.gray[600]};
  line-height: 24px;
  margin: 0 0 ${i.spacing*6}px 0;
  word-break: break-word;
`,p=e.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 40px;
  margin-bottom: ${i.spacing*4}px;
  .user {
    display: flex;
    align-items: center;
    gap: ${i.spacing*2}px;
    .details {
      display: flex;
      align-items: center;
      gap: ${i.spacing*2}px;
      .displayName {
        font-size: 16px;
        color: ${i.colors.gray[900]};
        line-height: 24px;
      }
      .date {
        font-size: 12px;
        color: ${i.colors.gray[400]};
        line-height: 24px;
      }
    }
  }
  @media screen and (max-width: ${i.breakpoints.lg}) {
    align-items: flex-start;
    .user {
      align-items: flex-start;
      .details {
        flex-direction: column;
        align-items: flex-start;
        gap: ${i.spacing}px;
      }
    }
  }
`,o=e.div`
  margin: 0;
  line-height: 24px;
  color: ${i.colors.gray[900]};
  word-break: break-word;
  font-size: 16px;
`,s=e.div`
  padding: 0 0 0 ${i.spacing*8}px;
`,t=e.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  > div {
    display: flex;
    gap: ${i.spacing*2}px;
    align-items: center;
    > span {
      font-size: 14px;
      color: ${i.colors.gray[900]};
    }
  }
`,g=e.div`
  > div {
    display: grid;
    grid-template-columns: 24px 1fr;
    grid-column-gap: ${i.spacing*2}px;
    align-items: center;
    margin-bottom: ${i.spacing*-2}px;
    > svg {
      width: 24px;
      height: 24px;
      > g, path {
        fill: ${i.colors.additional.green[300]};
      }
    }
    > span {
      font-size: 16px;
      color: ${i.colors.gray[900]}
    }
  }
`,l=e.div`
  background-color: ${i.colors.gray[50]};
  margin: ${i.spacing*-4}px;
  padding: ${i.spacing*4}px;
`;export{s as AnswerContainer,o as AnswerDescription,l as AnswerWrapper,a as Container,r as Description,t as Footer,g as ReferedByContainer,n as Title,p as UserContainer};
